import { Route, Routes } from "react-router-dom";

import UsersPage from "../../../pages/module-pages/administration/users/UsersPage";
import NotificationsPage from "../../../pages/module-pages/administration/notifications/NotificationsPage";
import BuyAndSellPage from "../../../pages/module-pages/administration/buy-and-sell/BuyAndSellPage";
import TransactionsPage from "../../../pages/module-pages/administration/transactions/TransactionsPage";
import AnnonceSystemePage from "../../../pages/module-pages/administration/annonces-systeme/AnnonceSystemePage";
import AlertsFraudesPage from "../../../pages/module-pages/administration/alerts-fraudes/AlertsFraudesPage";
import SettingsPage from "../../../pages/module-pages/administration/settings/SettingsPage";
import WalletsPage from "../../../pages/module-pages/administration/wallets/WalletsPage";
import ConcurrentsPage from "../../../pages/module-pages/administration/concurrents/ConcurrentsPage";
import VirementBancaireNav from "./sub-nav/VirementBancaireNav";
import AmbassadorsPage from "../../../pages/module-pages/administration/ambassadors/AmbassadorsPage";
import CountryTransfertsPage from "../../../pages/module-pages/administration/countries-transfert/CountryTransfertsPage";
import { UpdateUserPage } from "../../../pages/module-pages/administration/users/UpdateUserPage";
import WithdrawalRequestsPage from "../../../pages/module-pages/administration/withdrawal-request/WithdrawalRequestsPage";
import DailyRatesPage from "../../../pages/module-pages/administration/daily-rates/DailyRatesPage";

export default function AdministrationNav() {
  return (
    <Routes>
      <Route path="/users" element={<UsersPage />} />
      <Route path="/update-user" element={<UpdateUserPage />} />

      <Route path="/notifications" element={<NotificationsPage />} />
      <Route path="/buy-and-sell" element={<BuyAndSellPage />} />
      <Route path="/transactions" element={<TransactionsPage />} />
      <Route path="/virements-bancaires/*" element={<VirementBancaireNav />} />
      <Route path="/announcements-system" element={<AnnonceSystemePage />} />
      <Route path="/fraud-alerts" element={<AlertsFraudesPage />} />
      <Route path="/settings" element={<SettingsPage />} />
      <Route path="/wallets" element={<WalletsPage />} />
      <Route path="/concurrents" element={<ConcurrentsPage />} />
      <Route path="/ambassadors" element={<AmbassadorsPage />} />
      <Route path="/country-transferts" element={<CountryTransfertsPage />} />
      <Route path="/withdrawal-requests" element={<WithdrawalRequestsPage />} />
      <Route path="/daily-rates" element={<DailyRatesPage />} />
    </Routes>
  );
}
